import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../provider/authProvider";
import api from "../../api/axios";

const Logout = () => {
    const { setToken } = useAuth();
    const navigate = useNavigate();
    const [isLoggingOut, setIsLoggingOut] = useState(false);

    useEffect(() => {
        if (!isLoggingOut) {
            setIsLoggingOut(true);
            handleLogout();
        }
    }, []); // hanya sekali saat mount

    const handleLogout = async () => {
        try {
            await api.post('/logout');
            console.log('Logout successful');
        } catch (error) {
            console.log('Logout error:', error?.response?.data || error.message);
        } finally {
            setToken('');
            navigate('/login', { replace: true });
        }
    };

    return null;
};

export default Logout;